import { Topic } from './enums.js';
/** Границы сообщений и медиа. Дублируются в DTO бэкенда и в UI-валидации. */
export const MESSAGE_MAX_LENGTH = 2000;
/** Описание неполадки: столько же, сколько у сообщения — больше не нужно. */
export const ISSUE_TEXT_MAX_LENGTH = 2000;
export const MESSAGE_MIN_LENGTH = 1;
export const PHOTO_MAX_SIZE_BYTES = 10 * 1024 * 1024;
export const PHOTO_ALLOWED_MIME_TYPES = ['image/jpeg', 'image/png', 'image/webp'];
/**
 * Голосовые сообщения.
 *
 * Предел сорок мегабайт: пятнадцать минут при 96 кбит/с занимают около
 * одиннадцати, у техники Apple формат тяжелее — запас нужен.
 */
export const VOICE_MAX_DURATION_SEC = 900;
export const VOICE_MAX_SIZE_BYTES = 40 * 1024 * 1024;
/**
 * 96 кбит/с против прежних 32: на низком битрейте речь звучит глухо, «как из
 * бутылки». Четверть часа при этом весит около 11 МБ — вдвое ниже предела.
 */
export const VOICE_BITS_PER_SECOND = 96_000;
/** Сколько столбиков громкости рисуется в пузыре. */
export const VOICE_WAVEFORM_BARS = 48;
/**
 * Формат зависит от устройства и не выбирается: Android и настольные браузеры
 * записывают webm/opus, техника Apple — mp4/aac. Принимаются оба, тип
 * проверяется по сигнатуре файла.
 */
export const VOICE_ALLOWED_MIME_TYPES = [
    'audio/webm',
    'audio/ogg',
    'audio/mp4',
    'audio/aac',
    'audio/mpeg',
];
export const REPORT_COMMENT_MAX_LENGTH = 500;
/** Сколько символов оригинала показывается в цитате — остальное отсекается. */
export const QUOTE_PREVIEW_MAX_LENGTH = 140;
/** Сколько миллисекунд «печатает…» держится без обновления. */
export const TYPING_INDICATOR_TTL_MS = 4000;
/** Не чаще одного `typing` в этот интервал — экономия трафика. */
export const TYPING_THROTTLE_MS = 1500;
/** Отсрочка закрытия чата при обрыве связи: WebApp сворачивается при свайпе. */
export const DISCONNECT_GRACE_PERIOD_MS = 30_000;
export const TOPIC_EMOJI = {
    [Topic.FLIRT]: '💖',
    [Topic.CHAT]: '💬',
};
//# sourceMappingURL=constants.js.map